// Google Analytics 4 utility functions for tracking events
// This helps you track user interactions and conversions

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID;

// Track page views
export const pageview = (url: string) => {
  if (typeof window !== 'undefined' && window.gtag && GA_TRACKING_ID) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

// Track custom events
export const event = (action: string, parameters?: {
  event_category?: string;
  event_label?: string;
  value?: number;
  [key: string]: any;
}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, parameters);
  }
};

// Generic event tracking function
export const trackEvent = (eventName: string, parameters?: { [key: string]: any }) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, parameters);
  }
};

// Track specific business events
export const trackContactFormSubmission = (formData?: {
  source?: string;
  conversationLength?: number;
  timeSpent?: number;
}) => {
  event('contact_form_submit', {
    event_category: 'engagement',
    event_label: 'contact_form',
    ...formData
  });
};

// Contact Modal Tracking
export const trackContactModalOpen = (source: string) => {
  trackEvent('contact_modal_opened', {
    event_category: 'engagement',
    source: source,
    timestamp: new Date().toISOString()
  });
};

export const trackContactModalClose = (source: string, method: string) => {
  trackEvent('contact_modal_closed', {
    event_category: 'engagement',
    source: source,
    close_method: method,
    timestamp: new Date().toISOString()
  });
};

// Contact Form Step Tracking
export const trackContactFormStep = (step: string, data?: { [key: string]: any }) => {
  trackEvent('contact_form_step', {
    event_category: 'engagement',
    form_step: step,
    ...data
  });
};

// Contact CTA Clicks
export const trackContactCTAClick = (source: string, buttonText?: string) => {
  trackEvent('contact_cta_click', {
    event_category: 'engagement',
    source: source,
    button_text: buttonText,
    timestamp: new Date().toISOString()
  });
};

export const trackArticleView = (articleTitle: string) => {
  event('view_article', {
    event_category: 'content',
    event_label: articleTitle
  });
};

export const trackBrandPageView = (brandName: string) => {
  event('view_brand', {
    event_category: 'portfolio',
    event_label: brandName
  });
};

export const trackExperienceView = (experienceTitle: string) => {
  event('view_experience', {
    event_category: 'portfolio',
    event_label: experienceTitle
  });
};

export const trackTechStackView = (techName: string) => {
  event('view_tech', {
    event_category: 'skills',
    event_label: techName
  });
};

export const trackDownload = (fileName: string) => {
  event('file_download', {
    event_category: 'engagement',
    event_label: fileName
  });
};

export const trackExternalLink = (url: string) => {
  event('click_external_link', {
    event_category: 'engagement',
    event_label: url
  });
};
